import {
  makeObservable,
  observable,
  action,
  computed,
  runInAction,
} from "mobx";
import { IObservableInitialState } from "../../models/ICommon";
import {
  IAddFotaTestRequest,
  IFotaMozlReleaseDetail,
  IFotaTenantReleaseDetail,
  IFotaTenantReleaseList,
  IFotaTenantReleaseListVM,
  ITntFotaVm,
} from "../../models/response/IFotaResponse";
import * as baseService from "../service/base-service";
import URLConstants from "../../constants/url.constants";
import toast from "react-hot-toast";
import { formatMessage } from "../../translations/format-message";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { IFotaTenantAdmin } from "../../models/Form/IFotaForm";
import { initialFotaTenantState } from "../initial-state/get-all-fota-state";
import { getFotaSelectedViewFromLocalStorage, getLanguageFromLocalStorage } from "../../helpers/local-stotrage-helper";
import moment from "moment";
import { DATE_FORMAT, DATE_TIME_FORMAT, emptyValue, fotaView, getEffectiveDateTime } from "../../constants/common-constants";
import { initialValuesTenantAdmin} from '../initial-state/add-edit-system-admin-fota-state';

export class FotaStore {
  initialStateValue = {
    success: false,
    error: '',
    inProgress: false
  }
  error: string | null = null;
  inProgress: boolean = false;
  isSelectedView: string = getFotaSelectedViewFromLocalStorage();

  addUpdateFotaTenantState: IObservableInitialState = { ...this.initialStateValue }

  fotaTenantReleaseList: IFotaTenantReleaseListVM = initialFotaTenantState;
  fotaTenantReleaseState: IObservableInitialState = { ...this.initialStateValue }
  deleteFotaTenantState: IObservableInitialState = { ...this.initialStateValue }
  fotaTenantRelease: ITntFotaVm | undefined = undefined;  

  constructor() {
    makeObservable(this, {
      fotaTenantReleaseList: observable,
      fotaTenantRelease: observable,
      fotaTenantReleaseState: observable,
      deleteFotaTenantState: observable,
      addUpdateFotaTenantState: observable,
      inProgress: observable,
      error: observable,
      isSelectedView: observable,
      DeleteFotaTenantService: action,
      
      GetFotaTenantReleaseListService: action,
      GetFotaTenantReleaseByIdService: action,
      AddFotaTenantReleaseService: action,
      UpdateFotaTenantReleaseService: action,
      
      reset: action,
      resetAddUpdateFotaTenantState: action,
      
      resetFotaTenantReleaseState: action,
      resetDeleteFotaTenantState: action,
      
      getFotaTenantRelease: computed,
      getFotaTenantList: computed,
      getFotaTenantDetail: computed,
      setSelectedView: action,
    });
  }

  /**
   * Fetches a list of Fota items.
   * @param currentPage - Current page number.
   * @param pageSize - Number of items per page.
   */
  GetFotaTenantReleaseListService = (currentPage: number, pageSize: number, selectedView: string) => {
    runInAction(() => (this.inProgress = true));
    let url = "";
    switch(selectedView){
      case fotaView.MODEM:
        url = `${URLConstants.FotaModemEffectedReleaseList}?PageNo=${currentPage}&PageSize=${pageSize}`;
        break
      case fotaView.JET:
        url = `${URLConstants.FotaJetEffectedReleaseList}?PageNo=${currentPage}&PageSize=${pageSize}`;
        break
      default:
        url = `${URLConstants.FotaHostReleaseList}?PageNo=${currentPage}&PageSize=${pageSize}`;
    }
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaTenantReleaseListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaTenantReleaseList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };

  /**
    * This function is used to map fotaTenantReleaseList to Fota List suitable for Grid Component.
    * @returns Initial Fota Details
    */
  get getFotaTenantList(): IFotaTenantReleaseList[] {
    if (this.fotaTenantReleaseList && this.fotaTenantReleaseList?.Releases.length > 0)
        return this.fotaTenantReleaseList?.Releases.map((fota) => {
            let language = getLanguageFromLocalStorage();
            return {
                Id: fota.Id,
                Description: fota.Description ? fota.Description : "",
                Version: fota.Version,
                FileName: fota.FileName ? fota.FileName : emptyValue,
                FileType: fota.FileType,
                File: fota.File ? fota.File : "",
                CreatedBy: fota.CreatedBy,
                UpdatedBy: fota.UpdatedBy,
                CreatedDate: fota.CreatedDate ? moment(fota.CreatedDate).format(DATE_TIME_FORMAT) : "",
                UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
                EffectiveDateTimestamp: fota.EffectiveDateTimestamp ? moment(fota.EffectiveDateTimestamp).format(DATE_FORMAT) : "",
                Language: language,
                isEdit: true,
                isData: true,
                isDelete: true,
                isSchedule: true,
                isHistore: true,
            }
        })
    return [];
  }

  /**
   * Fetches Fota item details by ID.
   * @param id - ID of the Fota item.
   */
  GetFotaTenantReleaseByIdService = (id: number) => {
    runInAction(() => (this.fotaTenantReleaseState.inProgress = true));
    const url = `${URLConstants.FotaHostRelease}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ITntFotaVm>>) => {
        if (response.data.Error) {
          // runInAction(
          //   () => (this.fotaTenantReleaseState.error = response.data.Message)
          // );
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.fotaTenantRelease = {
              ...response.data.Data,
            };
            this.fotaTenantReleaseState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
        // runInAction(() => (this.fotaTenantReleaseState.error = err));
      })
      .finally(() => {
        runInAction(() => (this.fotaTenantReleaseState.inProgress = false));
      });
  };

  /**
   * Returns fotaTenantRelease which were fetched by Id
   */
  get getFotaTenantRelease(): IFotaTenantAdmin {
    if (this.fotaTenantRelease) 
      return {
        ...this.fotaTenantRelease,
        Version: this.fotaTenantRelease.Version,
        File: "",
        WantToUpdateFile:"false",
        FileName: "",
        IsCustomFileNameWithExtension: false,
        IsCustomFileNameWithoutExtension: false,
        HostVersionFileContent: this.fotaTenantRelease?.File ? this.fotaTenantRelease?.File : "",
        Description: this.fotaTenantRelease.Description,
    };
    return {...initialValuesTenantAdmin};
  }
  
  /**
   * Returns fotaTenantReleaseDetail which were fetched by Id
   */
  get getFotaTenantDetail(): IFotaTenantReleaseDetail | IFotaMozlReleaseDetail | undefined {
    if (this.fotaTenantRelease) 
      return {
        Version: this.fotaTenantRelease.Version,
        FileType: this.fotaTenantRelease.FileType,
        Description: this.fotaTenantRelease.Description,
        FileName: this.fotaTenantRelease.FileName || "",
        File: this.fotaTenantRelease.File,
        UpdatedDate: (this.fotaTenantRelease.UpdatedDate && this.fotaTenantRelease.UpdatedDate !== "1970-01-01T00:00:00.000Z") ? moment(this.fotaTenantRelease.UpdatedDate).format(DATE_TIME_FORMAT) : "",
        CreatedDate: (this.fotaTenantRelease.CreatedDate && this.fotaTenantRelease.CreatedDate !== "1970-01-01T00:00:00.000Z") ? moment(this.fotaTenantRelease.CreatedDate).format(DATE_TIME_FORMAT) : "",
    };
  }

  resetFotaTenantReleaseState = () =>{
    this.fotaTenantRelease = undefined;
    this.fotaTenantReleaseState = {...this.initialStateValue};
  }

  /**
   * Adds or updates a Fota for SystemAdmin.
   * @param data - Fota item data.
   */
  AddFotaTenantReleaseService = (data: IFotaTenantAdmin) => {
    this.addUpdateFotaTenantState.inProgress = true;
    const url = URLConstants.FotaHostRelease;
    return baseService.postRequest(url, {...data}).then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            this.addUpdateFotaTenantState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateFotaTenantState.inProgress = false;
      });
  };

  /**
   * Updates a Fota for SystemAdmin.
   * @param data - Fota item data.
   */
  UpdateFotaTenantReleaseService = (data: IFotaTenantAdmin, id: number) => {
    this.addUpdateFotaTenantState.inProgress = true;
    const url = URLConstants.FotaHostRelease;
    return baseService.putRequest(url, {...data, Id: id})
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            this.addUpdateFotaTenantState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateFotaTenantState.inProgress = false;
      });
  };

  resetAddUpdateFotaTenantState = () =>{
    this.addUpdateFotaTenantState = {...this.initialStateValue};
  }

  /**
    * This function is used to Delete User by calling an API.
    * @param id : The User Identifier
    * @returns 
    */
  DeleteFotaTenantService = (id: number) => {
    this.deleteFotaTenantState.inProgress = true;
    let url = `${URLConstants.FotaHostRelease}/${id}`;
    return baseService.deleteRequest(url)
        .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
            if (response.data.Error) {
                this.deleteFotaTenantState.error = response.data.Message;
                toast.error(formatMessage(response.data.Message));
            }
            else this.deleteFotaTenantState.success = true;
        })
        .catch((err: string) => {
            this.deleteFotaTenantState.error = err;
        }).finally(action(() => { this.deleteFotaTenantState.inProgress = false; }));
  }

  resetDeleteFotaTenantState = () => {
    this.deleteFotaTenantState = {...this.initialStateValue};
  };

  /**
   * Resets all observables to their initial values.
   */
  reset = () => {
    this.addUpdateFotaTenantState = {...this.initialStateValue};
  };

  setSelectedView = (modemView: string) => {
    this.isSelectedView = modemView;
    localStorage.setItem('mzl_selected_view', modemView)
}

}
const fotaStore = new FotaStore();
export default fotaStore;
